import { ItemType } from '@/modules/Breadcrumb/types'
import { seoDictionary } from './dictionary'

export const seoBreadcrumb: ItemType[] = [
  {
    title: seoDictionary.seo,
  },
]
